import React, { useEffect, FC } from "react";
import { Avatar, Checkbox, Grid, Typography } from "@material-ui/core";
import { FormControlLabel } from "@material-ui/core";
import {
  getFirstDayOfWeek,
  getRenkeiTaskIdList,
  TENPO_CHECK_BIG_RECORD,
  TENPO_CHECK_RECORD,
  updateRenkeiTaskItem,
} from "./TenpoCheckTableDataOperation";
import { getFirestoreDocData } from "../../../apis/firestoreAction";
import { RadioButtonUnchecked } from "@material-ui/icons";
import CloseIcon from "@material-ui/icons/Close";
import RemoveIcon from "@material-ui/icons/Remove";
import CheckBoxBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { stylesTenpoCheckTable } from "./StylesTenpoCheckRegister";
import { getFixedFlg } from "../../Header/Header";
import { isWorkProgress } from "../../../apis/privilege";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/userSlice";

const TenpoCheckSagyoWariatePrint: FC<{
  records: TENPO_CHECK_BIG_RECORD[];
  tenpoCheckId: string;
  approvalDate: string;
  wariateInfo?: (
    renkeiCount: number,
    renkeiFlg: boolean,
  ) => void;
  renkeiInfo?: (
    renkeiItemStr: string
  ) => void;
}> = ({ records, tenpoCheckId, approvalDate, wariateInfo, renkeiInfo}) => {
  const classes = stylesTenpoCheckTable();
  const user = useSelector(selectUser);

  const [displayFlg, setDisplayFlg] = React.useState(true);
  const [recordList, setRecordList] = React.useState<any[]>([]);
  const [renkeiCount, setRenkeiCount] = React.useState(0);
  const [displayRenkeiList, setDisplayRenkeiList] = React.useState<any[]>([]);
  const [weekList, setWeekList] = React.useState<any[]>([]);
  const [renkeiCount2, setRenkeiCount2] = React.useState(0);
  const [renkeiCount3, setRenkeiCount3] = React.useState(0);
  const [renkeiCount4, setRenkeiCount4] = React.useState(0);
  const [thisWeekRenkeiList, setThisWeekRenkeiList] = React.useState<any[]>([]);
  const [displayRecord, setDisplayRecord] = React.useState<any>();

  // 表示する営業計画支援システム連携リストを取得
  function getNgRecord(
    row: TENPO_CHECK_RECORD,
    taskIdList: any[],
    row2w: any,
    row3w: any,
    row4w: any
  ) {
    let targetList: any = [];

    let id = row.big_item_id + "-" + row.small_item_id;
    let no = row.small_title.split(". ")[0];
    let ngTargetList: any[] = [];
    let targetTaskIdList: any[] = [];

    for (let comment_map of row.reason_comment_map_list) {
      let targetValue = comment_map.value;
      let commentList = comment_map.comment_list;
      for (let commentMap of commentList) {
        if (
          commentMap.task_id &&
          taskIdList.indexOf(commentMap.task_id) !== -1
        ) {
          let buttonValue2 =
            row2w && row2w.records && row2w.records["records-" + id]
              ? row2w.records["records-" + id].button_value
              : "";
          let buttonValue3 =
            row3w && row3w.records && row3w.records["records-" + id]
              ? row3w.records["records-" + id].button_value
              : "";
          let buttonValue4 =
            row4w && row4w.records && row4w.records["records-" + id]
              ? row4w.records["records-" + id].button_value
              : "";
          if (
            buttonValue2 === "2" ||
            buttonValue3 === "2" ||
            buttonValue4 === "2"
          ) {
            ngTargetList.push({
              value: targetValue,
              comment: commentMap.value,
              taskId: commentMap.task_id,
            });
            targetTaskIdList.push(commentMap.task_id);
          }
        }
      }
    }

    for (let ngMap of row.user_ng_list) {
      if (ngMap.task_id && targetTaskIdList.indexOf(ngMap.task_id) === -1) {
        ngTargetList.push({
          value: ngMap.user_radio_target,
          comment: ngMap.user_radio_comment,
          taskId: ngMap.task_id,
        });
        targetTaskIdList.push(ngMap.task_id);
      }
    }

    for (let ngTarget of ngTargetList) {
      if (row.reason_target_list) {
        let targetName = "";
        let targetId = "";
        let commentValue = "";
        for (let reasonTarget of row.reason_target_list) {
          if (ngTarget.value === reasonTarget.value) {
            targetName = reasonTarget.name;
            targetId = reasonTarget.value;
          }
        }

        for (let reasonCommentMap of row.reason_comment_map_list) {
          if (ngTarget.value === reasonCommentMap.value) {
            for (let commentMap of reasonCommentMap.comment_list) {
              if (ngTarget.comment === commentMap.value) {
                commentValue = commentMap.name;
              }
            }
          }
        }
        targetList.push({
          bigItemId: row.big_item_id,
          smallItemId: row.small_item_id,
          targetId: targetId,
          id: id,
          no: no,
          taskId: ngTarget.taskId,
          name: targetName + " " + commentValue,
        });
      }
    }

    return targetList;
  }

  // 連携対象チェック時
  const changeCheckTarget = (targetRow: any) => {
    let addFlg = true;
    let workDisplayRenkeiList: any[] = [];

    if (displayRenkeiList) {
      for (let i = 0; i < displayRenkeiList.length; i++) {
        if (
          targetRow.bigItemId === displayRenkeiList[i].bigItemId &&
          targetRow.smallItemId === displayRenkeiList[i].smallItemId &&
          targetRow.targetId === displayRenkeiList[i].targetId &&
          targetRow.taskId === displayRenkeiList[i].taskId
        ) {
          addFlg = false;
          continue;
        }
        let renkeiMap = {
          bigItemId: displayRenkeiList[i].bigItemId,
          smallItemId: displayRenkeiList[i].smallItemId,
          targetId: displayRenkeiList[i].targetId,
          taskId: displayRenkeiList[i].taskId,
        };
        workDisplayRenkeiList.push(renkeiMap);
      }
    }
    if (addFlg) {
      let renkeiMap = {
        bigItemId: targetRow.bigItemId,
        smallItemId: targetRow.smallItemId,
        targetId: targetRow.targetId,
        taskId: targetRow.taskId,
      };
      workDisplayRenkeiList.push(renkeiMap);
    }
    let renkeiTaskIdList = getRenkeiTaskIdList(workDisplayRenkeiList);
    setRenkeiCount(renkeiTaskIdList.length);
    setDisplayRenkeiList(workDisplayRenkeiList);
    updateRenkeiTaskItem(tenpoCheckId, renkeiTaskIdList, workDisplayRenkeiList,
         displayRecord);

    if (wariateInfo) {
      wariateInfo(renkeiTaskIdList.length, true);
    }
    if (renkeiInfo) {
      let itemListName = "";
      for (let record of recordList) {
        if (isCheckedTarget(record, workDisplayRenkeiList)) {
          if (itemListName !== "") {
            itemListName += ",";
          }
          itemListName += record.title;
        }
      }
      renkeiInfo(itemListName);
    }
  };

  // チェックが入っているかを判定
  const isCheckedTarget = (row: any, renkeiList?: any[]) => {
    let workRenkeiList: any[] = displayRenkeiList;
    if (renkeiList) {
      workRenkeiList = renkeiList;
    }
    if (workRenkeiList) {
      for (let i = 0; i < workRenkeiList.length; i++) {
        if (
          row.bigItemId === workRenkeiList[i].bigItemId &&
          row.smallItemId === workRenkeiList[i].smallItemId &&
          row.targetId === workRenkeiList[i].targetId &&
          row.taskId === workRenkeiList[i].taskId
        ) {
          return true;
        }
      }
    }
    return false;
  };

  // 過去データを取得
  const getJsonlast3weeks = async (jsonObj: any) => {
    jsonObj.weekName = getFirstDayOfWeek(jsonObj.attribution.approve_day, 0);
    let jsonArr = [jsonObj];
    let last_time_id = jsonArr[0].attribution.last_time_id;
    // 過去4週分取得する
    for (let i = 0; i < 3; ) {
      try {
        if (last_time_id) {
          // Firestoreから取得
          let data: any = await getFirestoreDocData(
            "tenpo_check_records",
            last_time_id
          );
          if (data) {
            let this_week = getFirstDayOfWeek(data.attribution.approve_day, 0);
            let week_date = getFirstDayOfWeek(
              jsonArr[0].attribution.approve_day,
              -7 * i
            );
            let last_week_date = getFirstDayOfWeek(
              jsonArr[0].attribution.approve_day,
              -7 * (i + 1)
            );
            let complete_date = data.attribution.complete_date;
            last_time_id = data.attribution.last_time_id;
            if (complete_date && week_date !== this_week) {
              // 前週が1週以上が空いている場合
              while (this_week !== last_week_date && i < 4) {
                let employData: any = {
                  weekName: last_week_date,
                  noRecord: true,
                };
                jsonArr.push(employData);
                i++;

                last_week_date = getFirstDayOfWeek(
                  jsonArr[0].attribution.approve_day,
                  -7 * (i + 1)
                );
              }
              data.weekName = last_week_date;
              jsonArr.push(data);
              i++;
            }
          }
        } else {
          break;
        }
      } catch {
        break;
      }
    }
    return jsonArr;
  };

  const formatWeekName = (date: string) => {
    if (!date) return "-";
    return date.slice(4, 6) + "/" + date.slice(6);
  };

  const checkTaskIdExist = (taskId: string, taskIdList: string[]) => {
    if (!taskIdList) {
      return false;
    }
    if (taskIdList.includes(taskId)) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    async function getArrayJson() {
      const jsonObj = await getFirestoreDocData(
        "tenpo_check_records",
        tenpoCheckId
      );
      if (jsonObj) {
        setDisplayRecord(jsonObj);
        let recordObj: any = jsonObj;
        let tenpoCode = recordObj.attribution.tenpo_code;
        if (!isWorkProgress(user, tenpoCode)) {
          setDisplayFlg(false);
          return;
        }
        let renkeiList: any[] = recordObj.attribution.renkeiList;
        let displayRenkeiList: any[] = recordObj.attribution.displayRenkeiList;
        if (!renkeiList) {
          renkeiList = [];
        }
        if (!displayRenkeiList) {
          displayRenkeiList = [];
        }
        setDisplayRenkeiList(displayRenkeiList);
        setRenkeiCount(renkeiList ? renkeiList.length : 0);

        if (wariateInfo) {
          wariateInfo(displayRenkeiList.length, true);
        }
      }
      let jsonArr: any[] = await getJsonlast3weeks(jsonObj);
      return jsonArr;
    }
    getArrayJson().then((jsonArr: any) => {
      if (!jsonArr) {
        return;
      }
      let allrecord = [];
      let weekNameList = [];
      weekNameList.push(formatWeekName(jsonArr[0].weekName));
      weekNameList.push(formatWeekName(jsonArr[1] ? jsonArr[1].weekName : ""));
      weekNameList.push(formatWeekName(jsonArr[2] ? jsonArr[2].weekName : ""));
      weekNameList.push(formatWeekName(jsonArr[3] ? jsonArr[3].weekName : ""));
      setWeekList(weekNameList);

      let baseRenkeiList: any[] =
        jsonArr[0] &&
        jsonArr[0].attribution &&
        jsonArr[0].attribution.renkeiList
          ? jsonArr[0].attribution.renkeiList
          : [];
      setThisWeekRenkeiList(baseRenkeiList);

      let pastTaskIdList = [];
      let renkeiList2: any[] =
        jsonArr[1] &&
        jsonArr[1].attribution &&
        jsonArr[1].attribution.renkeiList
          ? jsonArr[1].attribution.renkeiList
          : [];
      let renkeiList3: any[] =
        jsonArr[2] &&
        jsonArr[2].attribution &&
        jsonArr[2].attribution.renkeiList
          ? jsonArr[2].attribution.renkeiList
          : [];
      let renkeiList4: any[] =
        jsonArr[3] &&
        jsonArr[3].attribution &&
        jsonArr[3].attribution.renkeiList
          ? jsonArr[3].attribution.renkeiList
          : [];

      pastTaskIdList.push(renkeiList2);
      pastTaskIdList.push(renkeiList3);
      pastTaskIdList.push(renkeiList4);

      setRenkeiCount2(renkeiList2.length);
      setRenkeiCount3(renkeiList3.length);
      setRenkeiCount4(renkeiList4.length);

      let renkeiDisplayList: any = [];
      for (let taskIdList of pastTaskIdList) {
        if (taskIdList) {
          for (let pastTaskId of taskIdList) {
            if (!renkeiDisplayList.includes(pastTaskId)) {
              renkeiDisplayList.push(pastTaskId);
            }
          }
        }
      }

      let itemListName = "";
      for (let record of records) {
        for (let row of record.rows) {
          let ngMaplist: any[] = getNgRecord(
            row,
            renkeiDisplayList,
            jsonArr[1],
            jsonArr[2],
            jsonArr[3]
          );
          for (let ngmap of ngMaplist) {
            if (isCheckedTarget(ngmap)) {
              if (itemListName !== "") {
                itemListName += ",";
              }
              itemListName += ngmap.name;
            }
            let record = {
              checked: ngmap.checked ? true : false,
              no: ngmap.no,
              bigItemId: ngmap.bigItemId,
              smallItemId: ngmap.smallItemId,
              targetId: ngmap.targetId,
              taskId: ngmap.taskId,
              title: ngmap.name,
              score1w: jsonArr[0].records["records-" + ngmap.id].button_value,
              taskIdList2w: pastTaskIdList[0],
              taskIdList3w: pastTaskIdList[1],
              taskIdList4w: pastTaskIdList[2],
              score2w:
                !jsonArr[1] || jsonArr[1].noRecord
                  ? ""
                  : jsonArr[1].records["records-" + ngmap.id].button_value,
              score3w:
                !jsonArr[2] || jsonArr[2].noRecord
                  ? ""
                  : jsonArr[2].records["records-" + ngmap.id].button_value,
              score4w:
                !jsonArr[3] || jsonArr[3].noRecord
                  ? ""
                  : jsonArr[3].records["records-" + ngmap.id].button_value,
            };
            allrecord.push(record);
          }
        }
      }
      if (renkeiInfo) {
        renkeiInfo(itemListName);
      }
      setRecordList(allrecord);
    });
  }, [records]);

  // マーク表示
  const MarkField: React.FC<{
    value: string;
  }> = ({ value }) => {
    const [inputValue] = React.useState(String(value));
    return (
      <>
        {inputValue === "1" ? (
          <Avatar
            className={classes.green}
            style={{ width: "30px", height: "30px" }}
          >
            <RadioButtonUnchecked style={{ fontSize: "20px" }} />
          </Avatar>
        ) : inputValue === "2" ? (
          <Avatar
            className={classes.red}
            style={{ width: "30px", height: "30px" }}
          >
            <CloseIcon fontSize={"small"} />
          </Avatar>
        ) : inputValue === "3" ? (
          <Avatar
            className={classes.gray}
            style={{ width: "30px", height: "30px" }}
          >
            <RemoveIcon fontSize={"small"} />
          </Avatar>
        ) : (
          ""
        )}
      </>
    );
  };

  return (
    <>
      {displayFlg ? (
        <>
          <Grid container style={{ paddingTop: "15px" }}>
            <Grid item xs={6}>
              <Typography variant="h6">
              営業計画支援システム連携項目数:{renkeiCount}
              </Typography>
            </Grid>
          </Grid>
          {recordList.length !== 0 ? (
            <>
              <Grid container xs={12}>
                <Grid item lg={4} md={4} sm={4}>
                  <Grid container>
                    <Grid item lg={1} md={1} sm={1} />
                    <Grid item lg={11} md={11} sm={11}>
                      {"項目"}
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={1} md={1} sm={1}>
                  {weekList[3]}
                </Grid>
                <Grid item lg={1} md={1} sm={1}>
                  {weekList[2]}
                </Grid>
                <Grid item lg={1} md={1} sm={1}>
                  {weekList[1]}
                </Grid>
                <Grid item lg={1} md={1} sm={1}>
                  {weekList[0]}
                </Grid>
              </Grid>

              <Grid container xs={12}>
                <Grid item lg={4} md={4} sm={4}>
                  <Grid container>
                    <Grid item lg={1} md={1} sm={1} />
                    <Grid item lg={11} md={11} sm={11}></Grid>
                  </Grid>
                </Grid>
                <Grid item lg={1} md={1} sm={1}>
                  ({renkeiCount4})
                </Grid>
                <Grid item lg={1} md={1} sm={1}>
                  ({renkeiCount3})
                </Grid>
                <Grid item lg={1} md={1} sm={1}>
                  ({renkeiCount2})
                </Grid>
                <Grid item lg={1} md={1} sm={1}>
                  ({renkeiCount})
                </Grid>
              </Grid>

              {recordList.map((row: any, indexRowItem: number) => (
                <Grid container>
                  <Grid item lg={4} md={4} sm={4}>
                    <FormControlLabel
                      key={row.taskId}
                      control={
                        <Checkbox
                          onChange={(e) => changeCheckTarget(row)}
                          checked={isCheckedTarget(row)}
                          disabled={
                            getFixedFlg() ||
                            thisWeekRenkeiList.indexOf(row.taskId) === -1
                              ? true
                              : false
                          }
                        />
                      }
                      label={row.no + " " + row.title}
                    />
                  </Grid>
                  <Grid item lg={1} md={1} sm={1}>
                    <Grid container>
                      <Grid item>
                        <MarkField value={row.score4w} />
                      </Grid>
                      <Grid
                        item
                        style={{ paddingLeft: "2px", paddingTop: "5px" }}
                      >
                        {row.score4w && row.score4w === "2" ? (
                          checkTaskIdExist(row.taskId, row.taskIdList4w) ? (
                            <CheckBoxIcon fontSize={"small"} />
                          ) : (
                            ""
                          )
                        ) : (
                          ""
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={1} md={1} sm={1}>
                    <Grid container>
                      <Grid item>
                        <MarkField value={row.score3w} />
                      </Grid>
                      <Grid
                        item
                        style={{ paddingLeft: "2px", paddingTop: "5px" }}
                      >
                        {row.score3w && row.score3w === "2" ? (
                          checkTaskIdExist(row.taskId, row.taskIdList3w) ? (
                            <CheckBoxIcon fontSize={"small"} />
                          ) : (
                            ""
                          )
                        ) : (
                          ""
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={1} md={1} sm={1}>
                    <Grid container>
                      <Grid item>
                        <MarkField value={row.score2w} />
                      </Grid>
                      <Grid
                        item
                        style={{ paddingLeft: "2px", paddingTop: "5px" }}
                      >
                        {row.score2w && row.score2w === "2" ? (
                          checkTaskIdExist(row.taskId, row.taskIdList2w) ? (
                            <CheckBoxIcon fontSize={"small"} />
                          ) : (
                            ""
                          )
                        ) : (
                          ""
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={1} md={1} sm={1}>
                    <MarkField value={row.score1w} />
                  </Grid>
                </Grid>
              ))}
            </>
          ) : (
            <>
              <Grid item xs={1}></Grid>
              <Grid item xs={11}>
                <Typography>営業計画支援システム連携項目なし</Typography>
              </Grid>
            </>
          )}
          <Grid container style={{ paddingBottom: "10px" }}></Grid>
        </>
      ) : (
        <></>
      )}
    </>
  );
};
export default TenpoCheckSagyoWariatePrint;
